import React, { useState } from 'react';
import Select from 'react-select';
import {
  HStack,
  Input,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  CloseButton,
} from '@chakra-ui/react';
import { DiceDictionary } from '../Contexts/ConstantsCollection.js';

const AdditionalDamageRow = ({
  id,
  amount,
  typeText = 'Damage Type',
  onAmountChange,
  onSidesChange,
  onTypeChange,
  onRemove,
}) => {
  const options = Object.entries(DiceDictionary).map(
    ([k, [sides, IconComp]]) => ({
      id: k,
      value: sides,
      icon: IconComp ? <IconComp style={{ fontSize: '1.2rem' }} /> : null,
    })
  );
  const [sides, setSides] = useState(options[0]);
  return (
    <HStack key={id} spacing={3}>
      <NumberInput
        min={0}
        max={10}
        width="75px"
        value={amount}
        onChange={v => onAmountChange(id, Number(v || 0))}
      >
        <NumberInputField border="2px solid black" height="40px" />
        <NumberInputStepper>
          <NumberIncrementStepper />
          <NumberDecrementStepper />
        </NumberInputStepper>
      </NumberInput>

      <Select
        options={options}
        value={sides}
        onChange={o => {
          setSides(o);
          onSidesChange(id, o.id);
        }}
        isSearchable={false}
        getOptionLabel={opt => (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {opt.icon}
          </div>
        )}
        styles={{
          container: s => ({
            ...s,
            width: '95px',
            border: '2px solid black',
            borderRadius: '8px',
          }),
        }}
      />
      <Input
        width={'50%'}
        onChange={e => onTypeChange(id, e.target.value)}
        placeholder={typeText}
      />
      <CloseButton onClick={() => onRemove(id)} width={'8%'} />
    </HStack>
  );
};

export default AdditionalDamageRow;
